import React from 'react';

import LoadMoreComponent from '../../../components/LoadMoreComponent';
import { query } from './query';
import CheckData from '../../../components/CatchError';
import DataTable from '../../../components/Datatable';
import { COLUMNS } from './keys';
import Search from '../../../components/Search';
import { scrollForTable } from '../../../components/Datatable/utils';
import AdditionalBox from './additionalBox';
import SettingsModal from './SettingsModal';
import { withTranslation } from 'react-i18next';

class Items extends LoadMoreComponent {
    constructor(props) {
        super();
        this.query = query({
            offset: 0,
            search: null,
            seasonKeywords: props.seasons?.[0]?.keywords,
        });
        this.offsetStep = 1000;
        this.onSelect = this.onSelect.bind(this);

        this.getData = this.getData.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({ selectedItems: state.ids, removeAllSelected: false });
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.keyword?.toLowerCase().includes(search.toLowerCase()));
    }

    async getData(value, search) {
        this.query = query({
            offset: 0,
            seasonKeywords: this.props.seasons?.find((item) => item.id === value)?.keywords,
            search: search ?? this.state.search,
        });
        this.query.bind(this.setState.bind(this));
        this.setState({ season: value, allData: [] });

        await this.query.update();
    }

    onSearch(value) {
        this.setState({
            search: value,
        });
        this.getData(this.state.season, value);
    }

    render() {
        const { t } = this.props;

        const attr = {
            query,
            offsetStep: this.offsetStep,
            seasonKeywords: this.props.seasons?.find((item) => item.id === this.state.season)
                ?.keywords,
            search: this.state.search,
        };

        const sortFns = {
            keyword: (array) => array.sort((a, b) => a.keyword.localeCompare(b.keyword)),
            seen: (array) =>
                array.sort((a, b) => new Date(a.firstSeen?.value) - new Date(b.firstSeen?.value)),
            maxClicks: (array) => array.sort((a, b) => a.maxClicks - b.maxClicks),
            avgClicks: (array) => array.sort((a, b) => a.avgClicks - b.avgClicks),
            avgURLs: (array) => array.sort((a, b) => a.avgURLs - b.avgURLs),
            avgPosition: (array) => array.sort((a, b) => a.avgPosition - b.avgPosition),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            avgCTR: (array) => array.sort((a, b) => a.avgCTR - b.avgCTR),
        };

        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const customeSearch = (
            <Search
                onSubmit={this.onSearch}
                placeholder={t('search.custom_keywords.search')}
                defaultValue={this.state.search}
            />
        );

        const selectedItems = this.state.selectedItems?.map((id) => ({
            id,
            keyword: this.state.allData.find((item) => item.id === id).keyword,
        }));
        const additionalBox = () => (
            <AdditionalBox
                current_url={this.props.current_url}
                csrf_token={this.props.csrf_token}
                selectedItems={selectedItems}
                onRemoveAllSelected={this.props.onRemoveAllSelected}
                season={this.state.season ?? this.props.seasons[0]?.id}
                seasons={this.props.seasons}
                getData={this.getData}
                onOpenSettingsModal={this.props.onOpenSettingsModal}
                t={t}
            />
        );

        const extraHeaders = (
            <SettingsModal
                endpoint_url={this.props.current_url}
                csrf_token={this.props.csrf_token}
                getSeasons={this.props.getSeasons}
                seasons={this.state.seasons}
                isOpen={this.props.isOpen}
                onOpenSettingsModal={this.props.onOpenSettingsModal}
                onCloseSettingsModal={this.props.onCloseSettingsModal}
            />
        );

        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={this.state.allData}
                    loading={this.state.loading}
                    loadMore={this.state.loadMore}
                    customCheck
                    customCheckCondition={!!this.state.season || !!this.state.search}
                >
                    <DataTable
                        nodes={this.state.allData}
                        sortFns={sortFns}
                        COLUMNS={COLUMNS(t)}
                        additionalBox={additionalBox}
                        fileName={t('search.custom_keywords.header')}
                        header={t('search.custom_keywords.header')}
                        extraHeaders={extraHeaders}
                        searchFunction={this.searchFunction}
                        defaultSortKey="maxClicks"
                        customContainerStyles="customize-settings-icon"
                        forceRun={this.forceRun}
                        removeAllSelected={this.state.removeAllSelected}
                        hasSelect={true}
                        customeSearch={customeSearch}
                        onSelect={this.onSelect}
                        dataLoading={this.props.loading}
                        showLoadMoreBtn={showLoadMoreBtn}
                        loadMoreLoading={this.state.loadMore}
                        loadMore={() => this.loadMore(attr)}
                        additionalStyles={{
                            Table: `
                                    --data-table-library_grid-template-columns : minmax(60px, 0.5fr) minmax(200px, 3fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                   ${scrollForTable}
                                `,
                            BaseCell: ` font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px !important;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        `,
                        }}
                    />
                </CheckData>
            </>
        );
    }
}

export default withTranslation()(Items);
